import { Component, Input, ViewChild } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { ReportCriteriaItemModel } from '../models/report-criteria-item.model';
import { ReportService } from '../services/report.service';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatButton } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout';
import { ReportCriteriaItemComponent } from './report-criteria-item/report-criteria-item.component';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'report-criteria',
    templateUrl: './report-criteria.component.html',
    styleUrls: ['./report-criteria.component.css'],
    providers: [ReportService],
    standalone: true,
    imports: [NgFor, NgIf, ReportCriteriaItemComponent, ReactiveFormsModule, FlexModule, MatButton, MatMenuTrigger, MatMenu, MatMenuItem]
})
export class ReportCriteriaComponent {
  @ViewChild('formContainer', { static: true }) formContainer;

  @Input() availableCriteria: ReportCriteriaItemModel[];
  @Input() criteriaForm: UntypedFormGroup;

  constructor(private reportService: ReportService) {}

  useCriterion(criterion: ReportCriteriaItemModel) {
    criterion.used = true;
  }
}
